import { NurseryModel } from "../../datastore/entities/nursery.model";
import { PromotionModel } from "../../datastore/entities/promotion.model";

export class CarouselModel {
    public nursery: NurseryModel;
    public promotion: PromotionModel;

    constructor(
        nursery: NurseryModel,
        promotion: PromotionModel) {
        this.nursery = nursery;
        this.promotion = promotion;
    }
}
